const comments = [
  {
    name: '追漫少年阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20boy%20avatar%20with%20warm%20smile%2C%20simple%20flat%20illustration%2C%20orange%20and%20cream%20color%20palette%2C%20minimal%20clean%20style&width=100&height=100&seq=avatar-comment-01&orientation=squarish',
    text: '酷漫屋真的太好用了！下拉式滚动阅读太舒服了，终于不用每话都点翻页按钮了。日漫资源也非常全，我想看的冷门作品居然都有，太惊喜了！',
    tag: '日漫爱好者',
    time: '2天前',
  },
  {
    name: '韩漫控小美',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20with%20gentle%20expression%2C%20simple%20flat%20illustration%2C%20pink%20and%20peach%20color%20palette%2C%20minimal%20clean%20style&width=100&height=100&seq=avatar-comment-02&orientation=squarish',
    text: '作为一个韩漫重度爱好者，酷漫屋的韩漫库真的没话说！《我独自升级》《全知读者视角》全都有，更新速度也跟得上，强烈推荐给所有喜欢看免费漫画的朋友。',
    tag: '韩漫达人',
    time: '3天前',
  },
  {
    name: '国漫支持者老陈',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20man%20avatar%20with%20confident%20look%2C%20simple%20flat%20illustration%2C%20golden%20and%20warm%20tone%2C%20minimal%20clean%20style&width=100&height=100&seq=avatar-comment-03&orientation=squarish',
    text: '国漫这几年真的进步太大了，酷漫屋的国漫专区做得很好，分类清晰、更新及时。镖人、一人之下这些精品都能免费在线阅读，为国漫打call！',
    tag: '国漫铁粉',
    time: '5天前',
  },
  {
    name: '漫画新人小白',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20character%20avatar%20with%20innocent%20expression%2C%20simple%20flat%20illustration%2C%20soft%20pastel%20color%2C%20minimal%20clean%20style&width=100&height=100&seq=avatar-comment-04&orientation=squarish',
    text: '刚入漫画坑不久，朋友推荐了酷漫屋，体验真的超赞！不用注册就能直接看，漫画免费资源很全，下拉滚动阅读对新手特别友好。',
    tag: '新入坑',
    time: '6天前',
  },
  {
    name: '十年老漫迷大刘',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20mature%20character%20avatar%20with%20wise%20expression%2C%20simple%20flat%20illustration%2C%20earthy%20warm%20tone%2C%20minimal%20clean%20style&width=100&height=100&seq=avatar-comment-05&orientation=squarish',
    text: '追了十几年漫画，用过很多免费漫画网站，酷漫屋是目前体验最好的。更新快、资源全、没广告骚扰，下拉式滚动阅读模式简直是追漫神器。',
    tag: '资深漫迷',
    time: '1周前',
  },
];

const colorMap = [
  { badge: 'bg-primary-100 text-primary-700', iconBg: 'bg-primary-100' },
  { badge: 'bg-secondary-100 text-secondary-700', iconBg: 'bg-secondary-100' },
  { badge: 'bg-accent-100 text-accent-700', iconBg: 'bg-accent-100' },
  { badge: 'bg-primary-100 text-primary-700', iconBg: 'bg-accent-100' },
  { badge: 'bg-secondary-100 text-secondary-700', iconBg: 'bg-secondary-100' },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          漫友心声
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          来自酷漫屋读者的真实评价
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {comments.map((comment, i) => {
            const c = colorMap[i];
            return (
              <div
                key={comment.name}
                className={`bg-background-50 rounded-2xl border border-background-200/80 p-5 ${
                  i === comments.length - 1 && comments.length % 2 === 1 ? 'md:col-span-2 md:max-w-md md:mx-auto md:w-full' : ''
                }`}
              >
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                    <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{comment.name}</span>
                      <span className={`text-xs px-1.5 py-0.5 rounded-md ${c.badge} whitespace-nowrap`}>{comment.tag}</span>
                    </div>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{comment.time}</span>
                  </div>
                  <div className="flex text-accent-500">
                    {[...Array(5)].map((_, j) => (
                      <i key={j} className="ri-star-fill text-xs"></i>
                    ))}
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}